import cartoonAPIexpress from '../assets/projects/cartoonAPIexpress.png'
import libraryindex from '../assets/projects/libraryindex.png'
import mountainmove from '../assets/projects/mountainmove.png'
import TodoMVC from '../assets/projects/TodoMVC.png'
import reactscreen from '../assets/projects/reactscreen.png'
import airbnbscreen from '../assets/projects/airbnbscreen.png'


export const data=[
    {
        id:1,
        name:"Cartoon Local API Application",
        image:cartoonAPIexpress,
        github:"https://github.com/LandFCreative/cartoondogsAPI",
        live:"https://cartoon-dog-api.onrender.com/",
    },
    {
        id:2,
        name:"Library Full Stack App",
        image:libraryindex,
        github:"https://github.com/LandFCreative/minilibraryupdate",
        live:"https://quaint-twill-cod.cyclic.app/",
    },
    {
        id:3,
        name:"Mountain Movement Website Design",
        image:mountainmove,
        github:"",
        live:"www.mountainmovementinvermere.ca",
    },
    {
        id:4,
        name:"To Do App",
        image:TodoMVC,
        github:"https://github.com/LandFCreative/todo-mvc-auth-local",
        live:"https://todo-with-authentication-f69h.onrender.com",
    },
    {
        id:5,
        name:"React Photo API with Tailwind",
        image:reactscreen,
        github:"https://github.com/LandFCreative/Reacttailwindphotoapi",
        live:"https://precious-gnome-09e42e.netlify.app",
    },
    {
        id:6,
        name:"React Airbnb Experience Page Cloned",
        image:airbnbscreen,
        github:"https://github.com/LandFCreative/ReactAirbnbclone",
        live:"https://symphonious-phoenix-6dfe06.netlify.app/",
    },

]
